export const MAX_SAFE = BigInt(Number.MAX_SAFE_INTEGER);
export const MAX_ENUMERATION = BigInt(10_000);
export const BIGINT_ZERO = BigInt(0);
export const BIGINT_ONE = BigInt(1);
